/* Clergy wishlist — no app, no account required.
 *
 * Product HANDLES live in localStorage. Handles, not variant IDs: a wishlist saves the
 * garment, not a particular size, and handles survive variant edits.
 *
 * Exposes window.clgWishlist:
 *   read()        -> array of handles, newest first
 *   has(handle)   -> bool
 *   toggle(h)     -> bool (true if now saved)
 *   remove(h)
 *   clear()
 *   paint()       -> re-sync every heart + counter on the page
 *
 * Fires `clg:wishlist:changed` on document with {items} so pages can react.
 *
 * Caveat worth knowing: localStorage is per-browser and per-device. Someone who saves on
 * their phone will not see it on their laptop. Cross-device would need customer accounts
 * plus a customer metafield.
 */
(function () {
  /* Bind once. If this file ever loads twice (a stale <script> left in theme.liquid, an
     app block, a duplicated snippet), the delegated click handler would bind twice and
     every toggle would immediately undo itself — a heart that looks completely dead. */
  if (window.clgWishlist) return;

  var KEY = 'clg-wishlist';
  var MAX = 100;

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(Boolean) : [];
    } catch (e) {
      return []; // private mode / disabled storage — degrade to "empty", never throw
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    paint();
    document.dispatchEvent(new CustomEvent('clg:wishlist:changed', { detail: { items: read() } }));
  }

  function has(handle) { return read().indexOf(handle) > -1; }

  function toggle(handle) {
    if (!handle) return false;
    var list = read(), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.unshift(handle);
    write(list);
    return list.indexOf(handle) > -1;
  }

  function remove(handle) {
    var list = read(), i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); write(list); }
  }

  function clear() { write([]); }

  // Re-sync every heart and counter. Safe to call after markup is swapped in.
  function paint() {
    var list = read(), n = list.length;

    document.querySelectorAll('[data-clg-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-clg-wish-link]').forEach(function (el) {
      el.classList.toggle('has-items', n > 0);
    });
    document.querySelectorAll('[data-clg-wish]').forEach(function (b) {
      var on = list.indexOf(b.dataset.clgWish) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = on ? b.dataset.labelOn : b.dataset.labelOff;
      if (lbl) b.setAttribute('aria-label', lbl);
    });
  }

  /* Delegated so hearts inside fetched/re-rendered markup work without rebinding.
     The heart sits next to a card link, so stop the click before it navigates. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-clg-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(b.dataset.clgWish);
    b.classList.toggle('just-added', on);
    if (on) setTimeout(function () { b.classList.remove('just-added'); }, 500);
  });

  // Another tab changed the list — keep this one honest.
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();
  // Back/forward cache restores the old DOM without re-running scripts.
  window.addEventListener('pageshow', paint);

  window.clgWishlist = { read: read, has: has, toggle: toggle, remove: remove, clear: clear, paint: paint };
})();
